import { produce } from 'immer'
import type { State } from '../../typings'
import { DiscountInfo } from './typings'

export function setDiscountProducer(
  state: State,
  payload: DiscountInfo,
): State {
  return produce(state, (draft) => {
    draft.referralDiscountCode = payload.referralDiscountCode
    draft.referralDiscountId = payload.referralDiscountId
  })
}
